import { Component, OnInit, ViewChild } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { AssignDefaultActionsComponent } from "./assign-default-actions/assign-default-actions.component";
import { AssignOptionalActionsComponent } from "./assign-optional-actions/assign-optional-actions.component";

@Component({
	selector: "app-assign-group-actions",
	templateUrl: "./assign-group-actions.component.html",
	styleUrls: ["./assign-group-actions.component.css"],
})
export class AssignGroupActionsComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		this.GroupName = this.SelectedGroup.GroupName;
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	SelectedGroup: any;
	GroupName: any = "";

	@ViewChild(AssignDefaultActionsComponent)
	DefaultRef: AssignDefaultActionsComponent;

	@ViewChild(AssignOptionalActionsComponent)
	OptionalRef: AssignOptionalActionsComponent;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAssign() {
		//Get list of Group Action IDs
		var lstActionInts: number[] = [];
		var lstPointsGroupTransactionIDs: number[] = [];

		//Add default actions
		for (var i = 0; i < this.DefaultRef.lstGroupAction.length; i++) {
			var next = this.DefaultRef.lstGroupAction[i];

			// console.log("Next");
			// console.log(next);

			if (next.GroupActionTypeID != 4) {
				lstActionInts = [...lstActionInts, next.GroupActionID];
			} else if (next.GroupActionTypeID == 4) {
				lstPointsGroupTransactionIDs = [...lstPointsGroupTransactionIDs, next.PointsGroupTransactionID];
			}
		}

		//Add optional actions that are selected
		for (var i = 0; i < this.OptionalRef.SelectedGroupActions.length; i++) {
			var next = this.OptionalRef.SelectedGroupActions[i];

			if (next.GroupActionTypeID != 4) {
				lstActionInts = [...lstActionInts, next.GroupActionID];
			} else if (next.GroupActionTypeID == 4) {
				lstPointsGroupTransactionIDs = [...lstPointsGroupTransactionIDs, next.PointsGroupTransactionID];
			}
		}

		var Info: any = {
			lstActionInts: lstActionInts,
			lstPointsGroupTransactionIDs: lstPointsGroupTransactionIDs,
		};

		// console.log("Info");
		// console.log(Info);

		this.ref.close(Info);
	}

	onCancel() {
		this.ref.close(-1);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////

	IsLoading() {
		if (this.DefaultRef == undefined) {
			return true;
		}
		if (this.OptionalRef == undefined) {
			return true;
		}

		return this.DefaultRef.loading == true || this.OptionalRef.loading == true;
	}

	/////////////////////////////////////////
}
